import * as React from "react";

// Hook allows to wrap request and return a loading state
// It keeps loading state until all the calls of this async function are finished
export const useAsyncLoadingFn = (
  asyncFn: (...args: any[]) => Promise<any>,
) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [loadingCount, setLoadingCount] = React.useState(0);

  React.useEffect(() => {
    setIsLoading(!!loadingCount);
  }, [loadingCount]);

  const controlledRequest = async (...args: any[]) => {
    setLoadingCount((prevCount) => prevCount + 1);
    try {
      return await asyncFn(...args);
    } finally {
      setLoadingCount((prevCount) => prevCount - 1);
    }
  };

  return [controlledRequest, isLoading];
};
